import React from 'react';
import { t } from '../../../../../../modules/infra/i18n';
import { range } from 'ramda';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import CurrencyInput from '../../../../../common/currencyInput';
import withOverridableCurrency from '../../../../../common/hoc/withOverridableCurrency';
import { tierKeyNameShape } from '../../shapes';

const tiers = range(1, 11);

const FlatRateForm = props => (
  <ReactTable
    data={tiers}
    showPagination={false}
    defaultPageSize={10000}
    minRows={0}
    className="c-table-new c-no-hover c-shop-commissions-table"
    sortable={false}
    resizable={false}
    columns={[
      {
        Header: null,
        Cell: ({ index }) => `${t('settings:commission.tier_label')} ${index + 1}`,
      },
      {
        width: 120,
        Header: () => `${t('settings:commission.sales_exceed_label')} (${props.currencySymbol})`,
        Cell: ({ index }) => (
          <CurrencyInput
            disabled={props.disabled}
            name={`shop.${props.tierKeyName}.${index}.amount`}
            className="c-input"
            parse={value => value && Number(value)}
          />
        ),
      },
      {
        width: 120,
        Header: () => `${t('settings:commission.incentive_label')} (${props.currencySymbol})`,
        Cell: ({ index }) => (
          <CurrencyInput
            disabled={props.disabled}
            name={`shop.${props.tierKeyName}.${index}.flatAmount`}
            className="c-input"
            parse={value => value && Number(value)}
          />
        ),
      },
    ]}
  />
);

FlatRateForm.propTypes = {
  tierKeyName: tierKeyNameShape.isRequired, // eslint-disable-line react/no-unused-prop-types
  currencySymbol: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default withOverridableCurrency(FlatRateForm);
